module.exports = __webpack_public_path__ + "img/24.03d82d2f.jpg";